import ReloadIcon from "../Icons/ReloadIcon";
import WarningTriangleIcon from "../Icons/WarningTriangleIcon";
import styles from "./rightsidebar.module.css";

const GENERIC_MESSAGES = new Set([
	"Could not load booking details. Please try again.",
	"Could not load sale details. Please try again.",
	"Something went wrong. Please try again.",
]);

const SidebarLoadError = ({ title, message, onReload, className = "" }) => {
	const detail = String(message || "").trim();
	const description = detail && !GENERIC_MESSAGES.has(detail)
		? detail
		: "Please try again.";

	return (
		<div className={`${styles.sidebarLoadError} ${className}`.trim()}>
			<div className={styles.sidebarLoadErrorIcon} aria-hidden="true">
				<WarningTriangleIcon width={22} height={20} color="currentColor" />
			</div>
			<h4>{title}</h4>
			<p>{description}</p>
			<button type="button" className={styles.sidebarLoadErrorButton} onClick={onReload}>
				<ReloadIcon size={14} color="currentColor" />
				Reload
			</button>
		</div>
	);
};

export default SidebarLoadError;
